import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Platform, ModalController, AlertController } from '@ionic/angular';

import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { NOTIFICATION_TYPES } from './constants/notifications.constants';
import { PromotionExchangedModalPage } from './promotions/promotion-exchanged-modal/promotion-exchanged-modal.page';
import { AuthService } from './auth/auth.service';
import { TranslocoService } from '@ngneat/transloco';

const NOTIFICATION_TOKEN = 'notif-token';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private uri = environment.url;

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private router: Router,
    private storage: Storage,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translocoService: TranslocoService
  ) {}

  init() {
    if (Capacitor.isPluginAvailable('PushNotifications')) {
      if (this.platform.is('android')) {
        PushNotifications.register();
      } else if (this.platform.is('ios')) {
        // Request permission to use push notifications
        // iOS will prompt user and return if they granted permission or not
        // Android will just grant without prompting
        PushNotifications.requestPermissions().then(result => {
          if (result.receive === 'granted') {
            // Register with Apple / Google to receive push via APNS/FCM
            PushNotifications.register();
          } else {
            // Show some error
          }
        });
      }

      PushNotifications.addListener(
        'registration',
        (token: Token) => {
          console.log(token.value);
          this.storage.set(NOTIFICATION_TOKEN, token.value);
        }
      );

      PushNotifications.addListener('registrationError', (error: any) => {
        console.log('Error on registration: ' + JSON.stringify(error));
      });

      PushNotifications.addListener(
        'pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          // Push received on foreground
          let redirect;
          let showPromotionModal = true;

          if (notification.data) {
            if (showPromotionModal) {
              this.modalCtrl
                .getTop()
                .then(res => {
                  if (res) {
                    res.dismiss();
                  }
                })
                .finally(() => {
                  let data;

                  try {
                    data = JSON.parse(notification.data.data);
                  } catch (err) {
                    data = undefined;
                  }

                  this.modalCtrl
                    .create({
                      component: PromotionExchangedModalPage,
                      componentProps: {
                        /* points:
                        notification.data && notification.data.data
                          ? notification.data.data.points
                          : 0, */
                        sponsor: data ? data.sponsor : undefined,
                        banner: data ? data.banner : undefined
                      }
                    })
                    .then(modal => modal.present());
                });
            } else if (notification.title && notification.body) {
              this.alertCtrl
                .create({
                  header: notification.title,
                  message: notification.body,
                  buttons: redirect
                    ? [
                        {
                          text: this.translocoService.translate('common.show'),
                          handler: () => {
                            this.router.navigateByUrl(redirect);
                          }
                        },
                        { text: this.translocoService.translate('common.cancel'), role: 'cancel' }
                      ]
                    : [{ text: this.translocoService.translate('common.accept'), role: 'cancel' }]
                })
                .then(alert => alert.present());
            }
          }

          console.log('Push received', notification);
        }
      );

      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          if (notification.actionId === 'tap') {
            let redirect;

            if (
              notification.notification.data &&
              notification.notification.data.event
            ) {
              switch (notification.notification.data.event) {
                case NOTIFICATION_TYPES.PROMOTION_EXCHANGED:
                  redirect = '/promotions';
                  break;
                case NOTIFICATION_TYPES.REWARD_EXCHANGED:
                  redirect = '/rewards';
                  break;
                case NOTIFICATION_TYPES.DEFAULT:
                  redirect = undefined;
                  break;
                case NOTIFICATION_TYPES.USER_ACTIVATED:
                  this.authService.doActivate();
                  return;
                default:
                  redirect = '/';
                  return;
              }

              if (redirect) {
                this.router.navigateByUrl(redirect);
              }
            }
          }
          console.log('Push action performed', notification);
        }
      );
    }
  }
}
